import React, { useState, useEffect } from 'react'

// Importa las funciones de tu BL (ajusta la ruta según tu estructura)
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from '../../utilities/BL/Zones'

// Importa el componente visual hijo (el que tiene los estilos y animación)
import { SelfieFan as SelfieFanOverlay } from './Overlays/SelfieFan'
import { FanMessages as FanMessagesOverlay } from './Overlays/FanMessages'


/**
 * COMPONENTE: SelfieFan OVERLAY (PARENT CONTAINER)
 * ------------------------------------------------------------------
 * Este componente es el "Cerebro" del Overlay. 
 * 1. Establece la conexión WebSocket como "overlay:selfiefan".
 * 2. Escucha los mensajes entrantes (SelfieFan y FanMessages).
 * 3. Gestiona la interrupción mutua entre dinámicas y cintillos.
 * 4. Pasa la información a <SelfieFanOverlay /> y <FanMessagesOverlay />.
 * ------------------------------------------------------------------
 */
const SelfieFan = () => {
    
    // --- ESTADOS DE CONEXIÓN Y DATOS ---
    const [selfieFanData, setSelfieFanData] = useState(null); // Payload para el hijo SelfieFan
    const [fanMessagesData, setFanMessagesData] = useState(null); // Payload para el hijo FanMessages
    const [overlayConfig, setOverlayConfig] = useState({ offsetX: 0, offsetY: 0, scale: 1 });
    const [connectionStatus, setConnectionStatus] = useState('idle');
    
    // -------------------------------------------------------------------------
    // EFECTO: FORZAR FONDO TRANSPARENTE
    // -------------------------------------------------------------------------
    useEffect(() => {
        const originalBodyStyle = document.body.style.backgroundColor;
        const originalHtmlStyle = document.documentElement.style.backgroundColor;
        const rootElement = document.getElementById('root'); 

        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        if (rootElement) {
            rootElement.style.backgroundColor = 'transparent';
        }

        return () => {
            document.body.style.backgroundColor = originalBodyStyle;
            document.documentElement.style.backgroundColor = originalHtmlStyle;
            if (rootElement) {
                rootElement.style.removeProperty('background-color');
            }
        };
    }, []); 

    // -------------------------------------------------------------------------
    // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
    // -------------------------------------------------------------------------
    useEffect(() => {
        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            const msgType = message.type.toLowerCase();

            // 1. Dinámica Selfie Fan
            if (msgType === 'selfiefan') {
                const payloadData = message.data;
                
                // Discriminamos qué acción mandó el Admin
                if (payloadData.action === 'show') {
                    // Si entra una foto, ocultamos el cintillo de FanMessages (interrupción mutua)
                    setFanMessagesData({ action: 'hide' });
                    setSelfieFanData(payloadData);
                } else if (payloadData.action === 'hide') {
                    setSelfieFanData(null);
                } else if (payloadData.action === 'config') {
                    // Actualizamos posiciones sin borrar la imagen actual
                    setOverlayConfig({
                        offsetX: payloadData.offsetX,
                        offsetY: payloadData.offsetY,
                        scale: payloadData.scale
                    });
                } else if (payloadData.action === 'show_qr') {
                    // Si entra el QR de dinámica, ocultamos el cintillo
                    setFanMessagesData({ action: 'hide' });
                    setSelfieFanData(payloadData); 
                }
            }

            // 2. Mensajes a la afición (FanMessages)
            if (msgType === 'fanmessages') {
                const payload = message.data || message;
                const target = message.targetOverlay || payload.targetOverlay || 'all';

                // Verificamos si este evento está dirigido a selfiefan o broadcast global
                if (target === 'selfiefan' || target === 'all') {
                    const action = (message.action || payload.action || '').toLowerCase();
                    const isShow = action === 'show' || message.isVisible === true || payload.isVisible === true;
                    const isHide = action === 'hide' || message.isVisible === false || payload.isVisible === false;

                    // Si entra un mensaje a la afición visible, pausamos/ocultamos la foto activa de Selfie Fan
                    if (isShow && !isHide) {
                        setSelfieFanData(null);
                    }
                    setFanMessagesData(message);
                }
            }
        };

        SetSocketMessageHandler(handleIncomingMessage);
        ConnectWebSocketForOverlay('selfiefan', (status) => setConnectionStatus(status), (msg) => console.log(msg));

        return () => { ClearSocketMessageHandler(); DisconnectWebSocket(); };
    }, []);

    // -------------------------------------------------------------------------
    // RENDERIZADO
    // -------------------------------------------------------------------------
    return (
        <>
            {/* Renderizamos el componente visual pasándole la data del socket. */}
            <SelfieFanOverlay data={selfieFanData} config={overlayConfig} /> 
            <FanMessagesOverlay data={fanMessagesData} />

            {/* Indicador de error de conexión (útil para debug en OBS) */}
            {connectionStatus === 'error' && (
                <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10, zIndex: 9999 }}>D</div>
            )}
        </>
    );
};

export { SelfieFan };









// import React, { useState, useEffect } from 'react'

// // Importa las funciones de tu BL (ajusta la ruta según tu estructura)
// import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'

// // Importa el componente visual hijo (el que tiene los estilos y animación)
// import { SelfieFan as SelfieFanOverlay } from './Overlays/SelfieFan'


// /**
//  * COMPONENTE: SelfieFan OVERLAY (PARENT CONTAINER)
//  * ------------------------------------------------------------------
//  * Este componente es el "Cerebro" del Overlay. 
//  * 1. Establece la conexión WebSocket como "overlay:selfiefan".
//  * 2. Escucha los mensajes entrantes.
//  * 3. Pasa la información al componente visual <SelfieFanOverlay />.
//  * ------------------------------------------------------------------
//  */
// const SelfieFan = () => {
    
//     // --- ESTADOS DE CONEXIÓN Y DATOS ---
//     const [selfieFanData, setSelfieFanData] = useState(null); // Payload para el hijo
//     // NUEVO: Estado separado para la configuración visual (Inicia en los valores por defecto)
//     const [overlayConfig, setOverlayConfig] = useState({ offsetX: 0, offsetY: 0, scale: 1 });
//     const [connectionStatus, setConnectionStatus] = useState('idle');
    
//     // -------------------------------------------------------------------------
//     // EFECTO: FORZAR FONDO TRANSPARENTE
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         // 1. Guardamos el color original por si acaso (buena práctica)
//         const originalBodyStyle = document.body.style.backgroundColor;
//         const originalHtmlStyle = document.documentElement.style.backgroundColor;
//         const rootElement = document.getElementById('root'); // El contenedor de React

//         // 2. Aplicamos la transparencia "a la fuerza"
//         document.body.style.backgroundColor = 'transparent';
//         document.documentElement.style.backgroundColor = 'transparent';
//         if (rootElement) {
//             rootElement.style.backgroundColor = 'transparent';
//         }

//         // 3. Cleanup: Cuando este componente se desmonte (cambies de pantalla),
//         // restauramos el color original (o lo dejamos vacío para que tome el CSS).
//         return () => {
//             document.body.style.backgroundColor = originalBodyStyle;
//             document.documentElement.style.backgroundColor = originalHtmlStyle;
//             if (rootElement) {
//                 rootElement.style.removeProperty('background-color');
//             }
//         };
//     }, []); // El array vacío asegura que esto corra solo al montar y desmontar

//     // Opcional: Si necesitas manejar el modo femenil/varonil aquí también
//     // const [isActiveWomensMode, setIsActiveWomensMode] = useState(false); 

//     // -------------------------------------------------------------------------
//     // CICLO DE VIDA: CONEXIÓN Y DESCONEXIÓN
//     // -------------------------------------------------------------------------
//     useEffect(() => {
//         const connect = async () => {
//             await ConnectWebSocketForOverlay('selfiefan', (status) => setConnectionStatus(status), (msg) => console.log(msg));
//             SetSocketMessageHandler(handleIncomingMessage);
//         };

//         const handleIncomingMessage = (message) => {
//             if (!message || !message.type) return;

//             if (message.type.toLowerCase() === 'selfiefan') {
//                 const payloadData = message.data;

//                 // Discriminamos qué acción mandó el Admin
//                 if (payloadData.action === 'show') {
//                     setSelfieFanData(payloadData); // Guardamos la imagen
//                 } else if (payloadData.action === 'hide') {
//                     setSelfieFanData(null); // Borramos la imagen
//                 } else if (payloadData.action === 'config') {
//                     // Actualizamos posiciones sin borrar la imagen
//                     setOverlayConfig({
//                         offsetX: payloadData.offsetX,
//                         offsetY: payloadData.offsetY,
//                         scale: payloadData.scale
//                     });
//                 }
//             }
//         };

//         connect();
//         return () => { ClearSocketMessageHandler(); DisconnectWebSocket(); };
//     }, []);

//     // -------------------------------------------------------------------------
//     // RENDERIZADO
//     // -------------------------------------------------------------------------
//     return (
//         <>
//             {/* Renderizamos el componente visual pasándole la data del socket.
//                 Si tuvieras lógica de Modo Femenil, pásala aquí también.
//             */}
//             <SelfieFanOverlay data={selfieFanData} config={overlayConfig} /> {/* isActiveWomensMode={isActiveWomensMode} */}

//             {/* Opcional: Indicador de error de conexión (útil para debug en OBS) */}
//             {connectionStatus === 'error' && (
//                 <div style={{ position: 'fixed', bottom: 0, right: 0, background: 'red', color: 'white', padding: 5, fontSize: 10 }}>D</div>
//             )}
//         </>
//     );
// };

// export { SelfieFan };